import { Component, Input, OnInit } from '@angular/core';

import { MessageService } from 'primeng/api';

import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { NegativeRecipientSearchService } from '../RemoveFromListsDialog/negative-recipient-search.service';
import { Observable } from 'rxjs';
import { EntityType } from '../../../../../api/targeting/enum/entity.type.enum';

export interface ListCheckbox {
    id: number;
    label: string;
    checked: boolean;
    recipientIds?: string[];
    entityType?: EntityType;
}

@Component({
    selector: 'agpr-remove-from-lists-confirm-dialog',
    templateUrl: './remove-from-lists-confirm-dialog.component.html',
    styleUrls: ['./remove-from-lists-confirm-dialog.component.scss'],
    standalone: false
})

export class RemoveFromListsConfirmDialogComponent extends AbstractDialogComponent implements OnInit {

    readonly id: string = 'recipientReport_removeRecipientFromListsConfirmDialog';
    readonly buttonTypesEnum = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    @Input() lists: ListCheckbox[];
    @Input() isAllRecipientsSelected: boolean;
    @Input() totalCount: number;

    selectedLists: Map<number, ListCheckbox> = new Map();

    constructor(
        public coreDialogService: CoreDialogService,
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public negativeRecipientSearchService: NegativeRecipientSearchService,
    ) {
        super(coreDialogService, 'RemoveFromListsConfirm');
    }

    ngOnInit(): void {
        this.lists.forEach(list => this.updateSelectedLists(list));
    }

    updateSelectedLists(list: ListCheckbox): void {
        const {id,  checked} = list;
        if(checked) {
            this.selectedLists.set(id, list);
        } else {
            this.selectedLists.delete(id);
        }
    }

    cancel(): void {
        this.closeDialog(false);
    }

    remove(): void {
        const lists = Array.from(this.selectedLists.values());
        const listIds = lists.map(list => list.id);

        let recipientCount = 0;
        let request: Observable<void>;
        if(this.isAllRecipientsSelected) {
            recipientCount = this.totalCount;
            request = this.negativeRecipientSearchService.removeAllRecipientsFromLists(listIds);
        } else {
            const entities = lists.flatMap(list => {
                const entityListKey =
                    list.entityType === EntityType.CONTACT ? 'contactUuid' : 'outletUuid';

                return list.recipientIds.map(recipientId => ({
                    [entityListKey]: recipientId
                }));
            });
            recipientCount = entities.length;
            request = this.negativeRecipientSearchService.removeSelectedRecipientsFromLists(entities, listIds);
        }
        request.subscribe({
            next: () => {
                this.messageService.add({
                    severity: messageSeverityEnum.success,
                    summary: 'Discover.distributionReport.recipient.removeFromListsConfirmDialog.success.header',
                    detail: this.localizationService.transform(
                        'Discover.distributionReport.recipient.removeFromListsConfirmDialog.success.detail',
                        {
                            recipientCount,
                            listCount: listIds.length
                        }
                    ),
                });
                this.negativeRecipientSearchService.reloadLists();
                this.closeDialog(true);
            },
            error: () => {
                this.messageService.add({
                    severity : messageSeverityEnum.error,
                    summary : 'Discover.distributionReport.recipient.removeFromListsConfirmDialog.error'
                });
            }
        });
    }

}
